import { render, staticRenderFns } from "./order-divider.vue?vue&type=template&id=8ca1f9b0"
import script from "./order-divider.vue?vue&type=script&lang=js"
export * from "./order-divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports